var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProtectionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 31,
    viewBox: "0 0 26 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 0L0 5.63636V14.0909C0 21.9114 5.54667 29.2245 13 31C20.4533 29.2245 26 21.9114 26 14.0909V5.63636L13 0ZM13 15.4859H23.1111C22.3456 21.2914 18.3733 26.4627 13 28.0832V15.5H2.88889V7.46818L13 3.08591V15.4859Z",
    fill: "#004BA5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProtectionIcon);
export default __webpack_public_path__ + "static/media/protectionIcon.1cf4688d64ec9d2dfece53e984446372.svg";
export { ForwardRef as ReactComponent };